<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Date"><br>
                                <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM-DD-YYYY hh:mm A" :placeholder="['Start Date', 'End Date']" style="width:100%"/>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Terminal">
                                <a-select mode="multiple" v-model="inputTerminal" showSearch placeholder="All Terminals" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                    <a-select-option v-for="option in terminalOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Cashier">
                                <a-select mode="multiple" v-model="inputCashier" showSearch placeholder="All Cashiers" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                    <a-select-option v-for="option in cashierOptions" :key="option.id" :value="option.id">{{option.first_name}} {{option.last_name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Payment Types">
                                <a-select mode="multiple" v-model="inputPaymentTypes" showSearch placeholder="All Payment Types" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                    <a-select-option v-for="option in paymentTypeOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Group By" >
                                <select class="form-control" v-model="inputGroupBy">
                                    <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" csv-title="E-Wallet_Payment_Report">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click="clearJsonData"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" name="E-Wallet_Payment_Report.xls" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12">
            <a-drawer title="" width="500" placement="right" @close="closeFilter" :visible="advancedFilterVisible">
                <advance-filter :parentParams="advancedFilterParams" @changeParams="changeParams" @closeFilter="closeFilter"></advance-filter>
            </a-drawer>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import AdvanceFilter from '../Bir Reports/ReportAdvanceFilter'
    import VueJsonToCsv from 'vue-json-to-csv';
    import {
        mapState,
        mapActions
    } from 'vuex'

    var component_x;

    export default {
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputGroupBy: 'document_date',
                groupOptions: [
                    {key: 'document_date', value: 'Business Date'},
                    {key: 'terminal_id', value: 'Terminal'},
                    {key: 'user_id', value: 'Cashier'},
                    {key: 'payment_type_id', value: 'Payment Type'}
                ],
                inputSite: [],
                inputTerminal: [],
                inputCashier: [],
                inputPaymentTypes: [],
                site_type: "ho",
                siteOptions: [],
                terminalOptions: [],
                cashierOptions: [],
                paymentTypeOptions: [],
                inputSortBy: 'grouper_id',
                sortOptions: [
                    {key: 'terminal', value: 'Terminal'},
                    {key: 'cashier', value: 'Cashier'},
                    {key: 'payment_type', value: 'Payment Type'}
                ],
    
                birSalesReports: [],
                inputLocation: [],
                locationOptions: [],
                toggleAdvanceFilter: false,
                toggleLabel: "Advanced Filter",
                advancedFilterParams: {},
                params: {},
                advancedFilterVisible: true,

                showSortInfo: 'asc',
                JsonData: [],
                inputBrand: null,
                brandOptions: [],
                subBrandOptions: [],
                inputSubBrands: [],
            }
        },
        mounted: async function () {
            component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            //Start get valid Terminals
            var terminals = await HTTPRequest.getRequest(component_x.endPoint + "terminals/get_valid_terminals?site_id=" + secureStorage.getItem("defaultSiteId"), null);
            component_x.terminalOptions = terminals;
            component_x.sort(component_x.terminalOptions);
            //End get valid Terminals
                
            //Start get valid payment types
            var payment_types = await HTTPRequest.getRequest(component_x.endPoint + "payment_types/get_valid_payment_types?is_req_reference_code=1", null);
            component_x.paymentTypeOptions = payment_types;
            component_x.sort(component_x.paymentTypeOptions);
            //End get valid payment types

            //Start get valid Cashiers
            var cashiers = await HTTPRequest.getRequest(component_x.endPoint + "users/get_valid_cashiers", null);
            component_x.cashierOptions = cashiers;
            // component_x.sort(component_x.cashierOptions);
            //End get valid Cashiers

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
        },
        computed: {
            ...mapState(['endPoint', 'categoriesOptions']),
        },
        components:{
            AdvanceFilter,VueJsonToCsv
        },
        watch: {
            isVatBreakdown: function() {
                if(this.isVatBreakdown == true){
                    this.isPercent = true
                    this.isNetReturn = false
                    this.isDiscount = false
                }
            }
        },
        methods: {
            ...mapActions(['updateCategoriesOptions']),
            moment,
            async onLocationChange(){
                // alert(this.inputLocation);
                this.siteOptions = await HTTPRequest.getRequest(component_x.endPoint + 'sites/get_valid_sites?location_id=' + this.inputLocation[this.inputLocation.length - 1], null)
                this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
                this.inputSite = this.siteOptions.map( s => s.id);
            },
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            showFixed(num, fixed) {
                fixed = fixed || 0;
                fixed = Math.pow(10, fixed);
                return Math.floor(num * fixed) / fixed;
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            formatNumber(num) {
               return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            advanceFilter(value){
                this.toggleAdvanceFilter = value
                if(this.toggleAdvanceFilter == true){
                    this.toggleLabel = "Collapse Filter"
                }else{
                    this.toggleLabel = "Advanced Filter"
                }
            },
            closeFilter(){
                this.advanceFilter(false)
            },
            changeParams(params, actualParams, mode){
                this.params = params
                this.advamcedFilterParams = actualParams

                if(mode == 'filter'){
                    this.advanceFilter(false);
                }
            },
            openNotificationWithIcon(type, msg) {
                if(type == 'error'){
                    this.$notification[type]({
                        message: 'Export Error',
                        description: msg
                    });
                }else if(type == 'warning'){
                    this.$notification[type]({
                        message: 'No Data Found',
                        description: msg
                    });
                }
            },
            generateReport: async function () {
                this.spinning= true;
                if(this.inputDate.length == 0){
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                    return
                }

                let from_header = this.inputDate[0].format('MMMM DD, YYYY')
                let to_header = this.inputDate[1].format('MMMM DD, YYYY')

                let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": this.inputDate[0].format('YYYY-MM-DD HH:mm:ss'),
                    "date_to": this.inputDate[1].format('YYYY-MM-DD HH:mm:ss'),
                    "terminal": this.inputTerminal.toString(),
                    "cashier": this.inputCashier.toString(),
                    "payment_type": this.inputPaymentTypes.toString(),
                    "order_by": this.inputGroupBy
                }

                let get_request = await HTTPRequest.getRequest(this.endPoint + 'wallet_payments?', parameters);
                
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }
                
                let siteSpecific = get_request;
            
                if(get_request.length > 0){
                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });
                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);
                    let group_text = ""
                    if(this.inputGroupBy != ''){
                        group_text = this.groupOptions.find(x => x.key === this.inputGroupBy).value
                    }
                    let headers = [];
                    headers = [
                            [
                                {content: 'Date/Time', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Terminal Name', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Trans. ID', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Trans. Reference', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Cashier', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Payment Type', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Status', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Total Amount', styles: {halign: 'center', valign: 'center'}}
                            ]
                        ]

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details
                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];

                        if(this.birSalesReports.length > 0){
                            let sub_total_amount_gross = 0
                            let sub_total_count = 0
                            let grand_total_amount_gross = 0
                            let grand_total_count = 0
                            let grouper = 'start'
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name
                                
                                if(grouper == 'start'){
                                    let detail_header = [{content: group_text + ' : ' + grouper_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.grouper_id){
                                        let detail_header = [{content: group_text + ' : ' + grouper_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.grouper_id
                                if( [null, ''].includes(reportLine.reference_code) )
                                    var ref_code = reportLine.meta_data.replace(/[{}:"|[\]\\]/g, '').split(",")[0].replace('reference_code', '')
                                else 
                                    var ref_code = reportLine.reference_code
                                    let detail = [
                                        reportLine.document_date,
                                        reportLine.terminal_name,
                                        reportLine.trans_id,
                                        ref_code,
                                        reportLine.cashier,
                                        reportLine.trans_type,
                                        reportLine.status,
                                        reportLine.amount
                                    ]
                                  
                                sub_total_count += 1
                                sub_total_amount_gross += Number(reportLine.amount)
                                grand_total_count += 1
                                grand_total_amount_gross += Number(reportLine.amount)

                                reportData.push(Object.assign({}, detail))
                    
                                if(i == this.birSalesReports.length-1){
                                    //Subtotal
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, ['', 'Transactions Count :', sub_total_count, '', '', '', 'Subtotal :',
                                            this.convertToCurrency(Number(sub_total_amount_gross))
                                        ]));
                
                                    //Grand Total
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, ['', 'Total Transactions Count:', grand_total_count, '', '', '', 'Grand Total :',
                                            this.convertToCurrency(Number(grand_total_amount_gross))
                                        ]));
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = reportLine.grouper_id
                                    next_grouper = this.birSalesReports[i+1].grouper_id

                                    if(current_grouper != next_grouper){
                                        //Subtotal
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, ['', 'Transactions Count :', sub_total_count, '', '', '', 'Subtotal :',
                                            this.convertToCurrency(Number(sub_total_amount_gross))
                                        ]));

                                        sub_total_count = 0
                                        sub_total_amount_gross = 0
                                    }
                                }
                                    
                            }
                        }

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"POS E-Wallet Payment Report By " + group_text)
                        doc.setFontType("normal");
                        doc.setFontSize(10);
    
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            doc.text(340,20,site_text,"right");
                        
                        doc.text(15,25,"For the Period of " + from_header + " to " + to_header)

                        let colStyles = {}
                        colStyles = {
                            0: {cellWidth: 30},
                            1: {cellWidth: 50},
                            2: {cellWidth: 30},
                            3: {cellWidth: 40},
                            4: {cellWidth: 60},
                            5: {cellWidth: 40},
                            6: {cellWidth: 25},
                            7: {cellWidth: 50}
                        }

                        doc.autoTable({
                            startY: 35,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            styles: {
                                cellPadding: 1.0, fontSize: 10,
                                halign: 'right'
                            },
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && data.row.raw[0] == 'Grand Total :'){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });
                    
                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportUtils.pdfTools.addFooter(doc, printed_by, "POS E-Wallet Payment Report By " + group_text, 340, 200, x+1, siteSpecific.length)

                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'warning', 'Try increasing the scope by adjusting the filters.');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                this.spinning= true;
                if(this.inputDate.length == 0){
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                    return
                }

                let from_header = this.inputDate[0].format('MMMM DD, YYYY')
                let to_header = this.inputDate[1].format('MMMM DD, YYYY')

                let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": this.inputDate[0].format('YYYY-MM-DD HH:mm:ss'),
                    "date_to": this.inputDate[1].format('YYYY-MM-DD HH:mm:ss'),
                    "terminal": this.inputTerminal.toString(),
                    "cashier": this.inputCashier.toString(),
                    "payment_type": this.inputPaymentTypes.toString(),
                    "order_by": this.inputGroupBy
                }

                let get_request = await HTTPRequest.getRequest(this.endPoint + 'wallet_payments?', parameters);
                
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }
                let siteSpecific = get_request;
                if(get_request.length > 0){
                    let siteSpecific = get_request;
                    let headers = ['Date/Time',' Terminal Name',' Trans ID',' Trans Reference',' Cashier',' Payment Type',' Status',' Total Amount'];
                    let site_specific = [];
                    let group_text = ""
                    if(this.inputGroupBy != ''){
                        group_text = this.groupOptions.find(x => x.key === this.inputGroupBy).value
                    }

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let reportData = [];
                        if(x > 0){
                            // Add second set of headers
                            reportData.push(headers)
                        }

                        if(this.birSalesReports.length > 0){
                            let sub_total_amount_gross = 0
                            let sub_total_count = 0
                            let grand_total_amount_gross = 0
                            let grand_total_count = 0
                            let grouper = 'start'
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name

                                if(grouper == 'start'){
                                    let detail_header = [group_text + ' : ' + grouper_name];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.grouper_id){
                                        let detail_header = [group_text + ' : ' + grouper_name];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.grouper_id
                                if( [null, ''].includes(reportLine.reference_code) )
                                    var ref_code = reportLine.meta_data.replace(/[{}:"|[\]\\]/g, '').split(",")[0].replace('reference_code', '')
                                else 
                                    var ref_code = reportLine.reference_code
                                let detail = [
                                    reportLine.document_date,
                                    String(reportLine.terminal_name),
                                    Number(reportLine.trans_id),
                                    String(ref_code),
                                    String(reportLine.cashier),
                                    String(reportLine.trans_type),
                                    String(reportLine.status),
                                    this.convertToCurrency(Number(reportLine.amount))
                                ]
                                sub_total_count += Number(1)
                                sub_total_amount_gross += Number(reportLine.amount)
                                grand_total_count += Number(1)
                                grand_total_amount_gross += Number(reportLine.amount)

                                reportData.push(Object.assign({}, detail))

                                if(i == this.birSalesReports.length-1){
                                    //Subtotal
                                    reportData.push(Object.assign({}, ['', 'Transactions Count : ' + Number(sub_total_count), '', '', '', '', 'Subtotal :',
                                            this.convertToCurrency(Number(sub_total_amount_gross))
                                        ]));
                
                                    //Grand Total
                                    reportData.push(Object.assign({}, ['', 'Total Transactions Count : ' + Number(grand_total_count), '', '', '', '', 'Grand Total :',
                                            this.convertToCurrency(Number(grand_total_amount_gross))
                                        ]));
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = reportLine.grouper_id
                                    next_grouper = this.birSalesReports[i+1].grouper_id

                                    if(current_grouper != next_grouper){
                                        //Subtotal
                                        reportData.push(Object.assign({}, ['', 'Transactions Count : ' + Number(sub_total_count), '', '', '', '', 'Subtotal :',
                                            this.convertToCurrency(Number(sub_total_amount_gross))
                                        ]));

                                        sub_total_count = 0
                                        sub_total_amount_gross = 0
                                    }
                                }
                            }

                        }

                        let site_text = ''
                        if(this.inputSite.length == 0){
                            site_text = 'All Sites'
                        } else {
                            let sites = this.inputSite
                            for (var s = 0; s < sites.length; s++) {
                                if(s == 0){
                                    site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                } else {
                                    site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                }
                            }
                        }
                        reportData.unshift([site_text]);
                        
                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }
                        reportData.push([])
                        reportData.push(["POS E-Wallet Payment Report By " + group_text, "Generated By: " + printed_by,"For the Period of " + from_header + " to " + to_header])
                        reportData.push([])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                    }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'warning', 'Try increasing the scope by adjusting the filters.');
                }
                this.spinning= false;
            },
            clearJsonData(){
              // console.log("working",this.JsonData)
              this.JsonData = [];
            },

            async getSubBrandData() {
                if (this.inputBrand != null) {
                    var subbrand_data = await HTTPRequest.getRequest(
                    this.endPoint +
                        "sub_brands/get_valid_sub_brands?brand_id=" +
                        this.inputBrand,
                    null
                    );
                    // console.log("sub_brand[index]:",subbrand_data);
                    this.subBrandOptions = subbrand_data;
                    // console.log(this.inputSubBrands)
                }
            },

            async clearSubBrand() {
                this.inputSubBrands = [];
            },
        }
    };
</script>

<style></style>
